<script lang="ts">
  import { tick } from "svelte";
  export let popoverClass: string = "";
  export let inverted: boolean = false;
  export let show: boolean = false;
  export let arrow: boolean = true;
  const WINDOW_PADDING = 40;

  let positionRef;
  let popoverRef;
  let popoverArrowRef;
  let popoverArrowPositionRef;

  async function prepareForShow() {
    var positioner = positionRef;
    if (!positioner) {
      return;
    }
    await tick();

    let popover = popoverRef;
    let popoverArrowPositioner = popoverArrowPositionRef;
    var popoverPosition = popover.getBoundingClientRect();

    // Position popover body
    if (popoverPosition.left < WINDOW_PADDING) {
      positioner.style.transform = "translateX(" + (WINDOW_PADDING - popoverPosition.left) + "px)";
      if (arrow) {
        popoverArrowPositioner.style.transform =
          "translateX(" + -(WINDOW_PADDING - popoverPosition.left) + "px)";
      }
    } else if (popoverPosition.right > window.innerWidth - WINDOW_PADDING) {
      positioner.style.transform =
        "translateX(" + (window.innerWidth - WINDOW_PADDING - popoverPosition.right) + "px)";
      if (arrow) {
        popoverArrowPositioner.style.transform =
          "translateX(" + -(window.innerWidth - WINDOW_PADDING - popoverPosition.right) + "px)";
      }
    }
  }

  function unprepare() {
    var positioner = positionRef;
    if (!positioner) {
      return;
    }
    positioner.style.transform = "";
  }

  $: {
    if (show) {
      prepareForShow();
    } else {
      unprepare();
    }
  }

  function clickOutside(node) {
    const handleClick = function ({ target }) {
      if (!node.contains(target) && !(target.nodeName == "A")) {
        window["closeTimer"] = setTimeout(function () {
          if (show) {
            show = false;
          }
        }, 100);
      } else {
        setTimeout(function () {
          if (window["closeTimer"]) {
            clearTimeout(window["closeTimer"]);
          }
        }, 10);
      }
    };

    setTimeout(function () {
      window.addEventListener("click", handleClick);
    }, 200);

    return {
      destroy() {
        window.removeEventListener("click", handleClick);
      },
    };
  }

</script>

<div class="popover-position" bind:this={positionRef}>
  {#if show}
    <div
      class="provi-popover {popoverClass}"
      class:popover--inverted={inverted}
      bind:this={popoverRef}
      use:clickOutside
    >
      {#if arrow}
        <div class="popover__arrow-position" bind:this={popoverArrowPositionRef}>
          <div class="popover__arrow" bind:this={popoverArrowRef} />
        </div>
      {/if}
      <slot />
    </div>
  {/if}
</div>
